import { useParams } from "react-router-dom";
import Page from "./Page";
import AddNewAccountData from "@/components/molecules/files/AddNewAccountData";

export default function NewAccount() {
  const { id } = useParams<{ id: string }>();

  return (
    <Page>
      <AddNewAccountData id={id} />
    </Page>
  );
}
